import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import {
  IntegrationProductListPage,
  productListSortEnum
} from "@/modules/product";
import { requireSuperAdmin } from "@/utils";

const integrationProductListSearchSchema = z.object({
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1),
  sort: fallback(productListSortEnum, "newest").default("newest")
});

export const Route = createFileRoute("/products/integration")({
  validateSearch: zodValidator(integrationProductListSearchSchema),
  beforeLoad: requireSuperAdmin,
  component: () => (
    <>
      <DocumentTitle
        title="Integration Product"
        description="Manage API integration for products on the LAMPU Marketplace."
      />
      <IntegrationProductListPage />
    </>
  )
});
